import React from 'react';
import ReactDOM from 'react-dom';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import reducers from './redux/reducers';
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import {composeWithDevTools} from 'redux-devtools-extension';

export const store = createStore(reducers, composeWithDevTools());

ReactDOM.render(<Provider store={store}><App/></Provider>, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js